import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration — the same summerlin-6bdc4 project the other gated
// STATAS sites (oneasia-corp, warrior) authenticate against, so a user
// authorised for one is authorised here without a second account.
const firebaseConfig = {
  apiKey: "AIzaSyDzbfUmcHgPle3GRljpho9iJmSXUlCk8v8",
  authDomain: "summerlin-6bdc4.firebaseapp.com",
  projectId: "summerlin-6bdc4",
  storageBucket: "summerlin-6bdc4.firebasestorage.app",
  messagingSenderId: "1099460179620",
  appId: "1:1099460179620:web:08d2e2bbd082c7ee2c5831",
  measurementId: "G-BQVQPE3VB1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
